<template>
	<div class="opening-animation-wrapper">
		<div class="opening-animation">
			<div class="bg-half" ref="animBgTopRef"></div>
			<div class="bg-half" ref="animBgBottomRef"></div>

			<div class="centered">
				<p class="opening-title" ref="animTitleRef">{{ getOrganizationName }}</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import {
	openingTitleMarqueeAndFadeOut,
	openingBackgroundSlideOut
} from '@rebuild/materials/shared/page_container/animation/animationContext';
import { onMounted, ref, computed } from 'vue';
import { useCommonData } from '@/hooks';
import { isDisabledAnimation } from '@rebuild/materials/shared/page_container/animation/animationContext';

const emit = defineEmits(['complete']);

const { getOrganizationName } = useCommonData();
const disabledOpeningAnimation = computed(() => isDisabledAnimation());

onMounted(() => {
	if (disabledOpeningAnimation.value) {
		emit('complete');
	}
});

const animTitleRef = ref(null);
const animBgTopRef = ref(null);
const animBgBottomRef = ref(null);

let titleAnimation = null,
	backgroundAnimation = null;

const createOpeningAnimation = () => {
	if (disabledOpeningAnimation.value) return;

	titleAnimation = openingTitleMarqueeAndFadeOut(animTitleRef.value);
	backgroundAnimation = openingBackgroundSlideOut([animBgTopRef.value, animBgBottomRef.value]);

	titleAnimation.then(() => {
		console.log('标题动画完成');
		backgroundAnimation.play();
	});
	backgroundAnimation.then(() => {
		console.log('背景动画完成, 开屏动画结束');
		emit('complete');
	});

	return [titleAnimation, backgroundAnimation];
};

const playOpeningAnimation = () => {
	if (titleAnimation) {
		titleAnimation.play();
	}
};

defineExpose({
	init: createOpeningAnimation,
	play: playOpeningAnimation
});
</script>

<style lang="less" scoped>
.opening-animation {
	height: 100vh;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 2002;

	.bg-half {
		position: absolute;
		left: 0;
		width: 100%;
		height: 50%;
		background: var(--theme-color);
		z-index: 10;
	}

	.centered {
		position: relative;
		z-index: 11;
	}
	.opening-title {
		color: var(--surf-inverse-color);
		text-align: center;
		font-family: HYYakuHei;
		font-size: 48px;
		font-style: normal;
		font-weight: 700;
		line-height: 160%;
	}
}
</style>
